module.exports = __webpack_public_path__ + "static/img/jiage.35039048.jpg";